import React, { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { OpenSierraSource, useSupportChat } from '../../../global/support-chat/use-support-chat';

// Extracted from wallet-provider-approval-pending so its `useSupportChat` import (which transitively
// pulls support-chat -> feature-gates -> the global-selectors store barrel) is NOT static. The error
// builder lazy-loads this component, so that closure only loads when a wallet-approval error actually
// renders — keeping it out of the eager error-service bundle that the login page imports.
export const LinkToSuncoChat = ({ children }) => {
  const { isEnabled, openSupportChat } = useSupportChat();
  const handleClick = useCallback(() => {
    openSupportChat(OpenSierraSource.WalletError);
  }, [openSupportChat]);

  return isEnabled ? (
    <Button onClick={handleClick} theme='link'>
      {children}
    </Button>
  ) : (
    children
  );
};
